import { render } from "./ExamIntro.vue?vue&type=template&id=51ea8aa4"
import script from "./ExamIntro.vue?vue&type=script&lang=js"
export * from "./ExamIntro.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__